export enum AuthModalStep {
    LOGIN = 'log-in',
    REGISTER = 'register',
}
